import { render, staticRenderFns } from "./EditCityClassify.vue?vue&type=template&id=63ba1fee&scoped=true&lang=pug&"
import script from "./EditCityClassify.vue?vue&type=script&lang=ts&"
export * from "./EditCityClassify.vue?vue&type=script&lang=ts&"
import style0 from "./EditCityClassify.vue?vue&type=style&index=0&id=63ba1fee&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63ba1fee",
  null
  
)

export default component.exports